
























import Component from "vue-class-component";
import Vue from "vue";
import Pagination from "@/common-class/pagination";
import OrderItem from "./orderItem.vue";
import moduleStore from "../store/index";
import NoData from "./noData.vue"
import { Toast } from "vant";

@Component({
  props: {
    currentDate: {
      type: Date,
      default: new Date(),
    }
  },
  components: { OrderItem,NoData},
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class indexPage extends Pagination {
  orderList = [];
  created() {}
  scrollTop = 0;
  toastLoading:any = null
  queryMonth = this.$props.currentDate.format("yyyy-MM")
  mounted() {
    if(this.$refs.list){
      const artListDom: any = (this.$refs.list as any).$el;
    // 当其滚动时，记录滚动后的top位置
    artListDom.addEventListener("scroll", () => {
      this.scrollTop = artListDom.scrollTop;
    });
    }
   
  }
  activated() {
    // 该路由组件激活时，记录滚动位置
    if(this.$refs.list){
      (this.$refs.list as any).$el.scrollTop = this.scrollTop;
    }
  }
  async getList() {
    try {
      this.queryMonth = this.$props.currentDate.format("yyyy-MM")
      this.toastLoading = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 2000,
      })
      const res = await (this as any).getOrderList({
        page: this.currentPage,
        size: this.pageSize,
        type: "FINISH",
        queryMonth: this.queryMonth
      });
      this.toastLoading.clear()
      if (this.refreshing) {
          this.orderList = [];
      }
      if (res.code == 200) {
        this.orderList.push(...res.data.results);
        this.totalPage = res.data.total_pages;
      }
      this.refreshing = false;
      this.loading = false;
      if (res.code != 200) this.error = true;
    } catch (err) {
      this.refreshing = false;
      this.loading = false;
      this.error = true;
    }
  }
  onRefresh() {
    // 下拉刷新
    this.orderList = [];
    this.refresh(() => {
      this.getList();
    });
  }
  onLoad() {
    // 上拉滚动加载
    console.log("加载");
    this.loadMore(() => {
      this.getList();
    });
  }
}
